module.exports = __webpack_public_path__ + "static/title_bg-70dc62e010fdba57ee520d61bcf33c67.jpg";